import { FontConfig } from "../types"

export const BODY_7XL_CONFIG: FontConfig = {
  title: "BODY/7xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 36, tw: "text-[36px]" },
    lineHeight: { px: 50, tw: "leading-[50px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 48, tw: "text-[48px]" },
    lineHeight: { px: 64, tw: "leading-[64px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 64, tw: "text-[64px]" },
    lineHeight: { px: 84, tw: "leading-[84px]" },
  },
}
